import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import Stack from "@mui/material/Stack";
import Box from "@mui/material/Box";
// Ce composant permet de d'éviter de rajouter un padding avant après par défaut aux items dynamiques, et de pouvoir appliquer l'espacement voulu si besoin.
const DynamicContainer = ({ children, spacing = 3, sx, }) => {
    const styles = {
        "& > *:not(.cms-core-append-button)": {
            p: "0px !important",
        },
        ...sx,
    };
    if (spacing !== undefined) {
        return (_jsx(Stack, { spacing: spacing, sx: styles, children: children }));
    }
    return _jsx(Box, { sx: styles, children: children });
};
export default DynamicContainer;
